import { useWriteContract } from 'wagmi';
import { LRSNODE_V3_CONTRACT_CONFIG } from '@/configs/lrsnode.config';

export function useNodeActionsV3() {
  const { writeContractAsync } = useWriteContract();

  const handleClaimNodeReward = async (nodeKey: string) => {
    try {
      const hash = await writeContractAsync({
        ...LRSNODE_V3_CONTRACT_CONFIG,
        functionName: 'claimRewardLRSNode',
        args: [nodeKey],
      });
      
      return { hash };
    } catch (error: any) {
      console.error('Failed to claim node rewards:', error);
      throw error;
    }
  };

  const handleRenewNode = async (nodeKey: string) => {
    try {
      const hash = await writeContractAsync({
        ...LRSNODE_V3_CONTRACT_CONFIG,
        functionName: 'renewNodeKey',
        args: [nodeKey],
      });
      
      return { hash };
    } catch (error) {
      console.error('Failed to renew node:', error);
      throw error;
    }
  };

  const handleClaimReferRewards = async (nodeKey: string, referCode: string) => {
    try {
      const hash = await writeContractAsync({
        ...LRSNODE_V3_CONTRACT_CONFIG,
        functionName: 'claimReferEarning',
        args: [nodeKey, referCode],
      });
      
      return { hash };
    } catch (error) {
      console.error('Failed to claim refer rewards:', error);
      throw error;
    }
  };

  const handleCreateReferCode = async (referCode: string) => {
    try {
      const hash = await writeContractAsync({
        ...LRSNODE_V3_CONTRACT_CONFIG,
        functionName: 'activateReferCode',
        args: [referCode],
      });
      
      return { hash };
    } catch (error: any) {
      console.error('Failed to create refer code:', error);
      throw error;
    }
  };

  const handleMigrateFromNode2 = async () => {
    const hash = await writeContractAsync({
      ...LRSNODE_V3_CONTRACT_CONFIG,
      functionName: 'migrateFromNode2',
      args: [],
    });
    return { hash };
  };

  return {
    handleClaimNodeReward,
    handleRenewNode,
    handleClaimReferRewards,
    handleCreateReferCode,
    handleMigrateFromNode2,
  };
}
